import React from "react";
import styled from "styled-components"


const AboutAddressesWrapper = styled.div`
    width: auto;
    max-width: 1024px;
    height: auto;
    margin-left: auto;
    margin-right: auto;
    margin-top: 40px;
    margin-bottom: 40px;
    padding-left: 20px;
    padding-right: 20px;
    display: flex;
    justify-content: center;
    column-gap: 40px;
    font-size: 1.25rem;

    @media (max-width: 767px) {
        flex-wrap: wrap;
        justify-content: space-around;
    }
`

const AboutAddressesItem = styled.div`
    max-width: 420px;

    > :first-child {
        font-weight: 400;
        margin-bottom: 20px;
    }

    @media (max-width: 767px) {
        width: 360px;
        max-width: none;
        margin-bottom: 40px;
    }
`

const AboutAddressesImg = styled.img`
    @media (max-width: 767px) {
        display: none;
    }
`

const AboutAddresses = ({ offices }) => {
    if (!offices?.length) {
        return null;
    }
    return (
            <AboutAddressesWrapper>
                {offices.map((office, index) => (
                    <React.Fragment key={index}>
                        {index > 0 && <AboutAddressesImg src="/images/about_vertical_line.png" />}
                        <AboutAddressesItem>
                            <p>
                                {office.title}
                            </p>
                            <p>
                                {office.address}<br/>
                                {office.phone}
                            </p>
                        </AboutAddressesItem>
                    </React.Fragment>
                ))}
            </AboutAddressesWrapper>
        );

}

export default AboutAddresses;
